<template>
    <div class="row row-wider">
        <div class="col-md-12" style="min-height: 150px;">
            <loader v-if="crSelectionLoading" />
            <form @submit.prevent="submit" class="form-horizontal" v-show="!crSelectionLoading">
                <tabs>
                    <tab header="File Search Sites">
                        <div class="form-group row" v-if="!formDisabled">
                            <button class="btn btn-default col-md-2 col-md-offset-8" v-on:click="selectAll()">Select All</button>
                            <div class="col-md-2">
                                <select class="form-control pull-right" v-model="selectdRecordingTypeId">
                                    <option value="">Select a value</option>
                                    <option v-for="recordingType in recordingTypeList" v-bind:value="recordingType.id" :key="recordingType.id">
                                        {{ recordingType.description}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <v-client-table :data="existingSiteList" :columns="siteListGridSpecColumns" :options="siteListGridSpec.options" ref="existingSiteGrid">
                            <template slot="select" slot-scope="props">
                                <div style="text-align: center" v-if="!formDisabled">
                                    <input type="checkbox" v-model="selectedRecordingList" v-bind:id="props.row.culturalResourceRecordingId" v-bind:value="props.row.culturalResourceRecordingId" />
                                </div>
                            </template>
                            <template slot="edit" slot-scope="props">
                                <div style="text-align: center" v-show="props.row.hasWorkflow && (!formDisabled || isShpoCrNorm || hasShpoRcDeskReview)">
                                    <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="goRecording(props.row.culturalResourceRecordingId)"></a> -->
                                    <router-link :to="{ path: '/CulturalResourceRecording/' + props.row.culturalResourceRecordingId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                                </div>
                            </template>
                            <template slot="recordingType" slot-scope="props">
                                <div>
                                    <select class="form-control" v-model="props.row.recordingTypeId" v-on:change="markChanged(props.row.culturalResourceRecordingId, $event)"
                                        :disabled="(
                                            formDisabled && //formDisabled passed from investigation
                                            !isShpoCrNorm && //is not Shpo Cr Normalization 
                                            !(hasShpoRcDeskReview && (
                                                //excludedRecordingTypes.includes(Number(props.row.recordingTypeId)) ||
                                                //props.row.recordingTypeId === recordingTypeEnum.InternalReview ||
                                                !props.row.hasWorkflow ||
                                                !props.row.recordingTypeId)) //is not (SHPO RC Review and don't have worflow)
                                            )">
                                        <option value="" :disabled="true">Select a value</option>
                                        <option v-for="recordingType in recordingTypeList" v-bind:value="recordingType.id"
                                            :disabled="existingSiteOptionIsDisabled(recordingType.id, props.row.recordingTypeId)" v-bind:key="recordingType.id">
                                            {{ recordingType.description}}
                                        </option>
                                    </select>
                                </div>
                            </template>
                            <template slot="isApe" slot-scope="props">
                                <div style="text-align: center">
                                    <input type="checkbox" v-model="props.row.isApe" :disabled="(props.row.recordingTypeId === 7) || formDisabled" v-on:change="setChecked(props.row.culturalResourceId, props.row.isApe)">
                                </div>
                            </template>
                            <template slot="delete" slot-scope="props">
                                <div style="text-align: center" v-if="!formDisabled">
                                    <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deleteRecording(props.row)"></a>
                                </div>
                            </template>
                        </v-client-table>
                        <div class="col-md-12" v-if="!formDisabled || hasShpoRcDeskReview">
                            <button class="btn btn-primary pull-left" v-on:click="saveExisting()">Save</button>
                            <button type="button" class="btn btn-primary form-control pull-right" style="width:200px" :disabled="crSelectionLoading" v-on:click="addFileSearchSnrSites()" >Add File Search Sites</button>
                        </div>
                    </tab>
                    <tab header="Added Sites">
                        <v-client-table ref="newSiteTable" :data="newSiteList" :columns="siteListGridSpecColumns" :options="siteListGridSpec.options">
                            <!-- <template slot="select" slot-scope="props">
                                <div style="text-align: center" >
                                    <input type="checkbox">
                                </div>
                            </template> -->
                            <template slot="edit" slot-scope="props">
                                <div style="text-align: center" v-show="props.row.hasWorkflow && (!formDisabled || isShpoCrNorm || hasShpoRcDeskReview)">
                                    <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="goRecording(props.row.culturalResourceRecordingId)"></a> -->
                                    <router-link :to="{ path: '/CulturalResourceRecording/' + props.row.culturalResourceRecordingId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                                </div>
                            </template>
                            <template slot="recordingType" slot-scope="props">
                                <div>
                                    <select class="form-control" v-model="props.row.recordingTypeId" v-on:change="markNew(props.row, $event)"
                                        :disabled="props.row.recordingTypeId ? formDisabled : (formDisabled && !isShpoCrNorm && !hasShpoRcDeskReview)">
                                        <option value="" disabled>Select a value</option>
                                        <option v-for="recordingType in recordingTypeList" v-bind:value="recordingType.id"
                                            :disabled="optionIsDisabled(recordingType.id)" v-bind:key="recordingType.id">
                                            {{ recordingType.description}}
                                        </option>
                                        <option v-if="props.row.recordingTypeId === recordingTypeEnum.FirstRecording" v-bind:value="recordingTypeEnum.FirstRecording">
                                            {{'First Recording'}}
                                        </option>
                                    </select>
                                </div>
                            </template>
                            <template slot="isApe" slot-scope="props">
                                <div style="text-align: center">
                                    <input type="checkbox" v-model="props.row.isApe" :disabled="(props.row.recordingTypeId === 7) || formDisabled" v-on:change="setChecked(props.row.culturalResourceId, props.row.isApe)">
                                </div>
                            </template>
                            <template slot="delete" slot-scope="props">
                                <div style="text-align: center">
                                    <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deleteRecording(props.row)"></a>
                                </div>
                            </template>
                        </v-client-table>
                        <div class="form-group">
                            <label class="col-md-2 control-label">&nbsp;</label>
                            <div class="col-md-4">
                                <div v-show="crrValidationResult && crrValidationResult.messages && crrValidationResult.messages.length > 0">
                                    <span class="has-error">Error on delete:</span>
                                    <ul class="has-error">
                                        <li v-for="message in crrValidationResult.messages" v-bind:key="message">{{ message }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div  class="col-md-12">
                            <button class="btn btn-primary pull-left" v-on:click="saveNew()" v-if="!formDisabled || isShpoCrNorm || hasShpoRcDeskReview">Save</button>
                            <button type="button" class="btn btn-primary form-control pull-right" style="width:95px" v-on:click="showSearch()" v-if="!formDisabled || isShpoCrNorm || hasShpoRcDeskReview">Add New</button>
                        </div>
                    </tab>
                    <tab header="Isolated Resources">
                        <div class="row">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width:10%" v-if="!formDisabled">Edit</th>
                                        <th style="width:20%">File Number</th>
                                        <th style="width:20%">Curation Number</th>
                                        <th style="width:20%">Type</th>
                                        <th style="width:20%">Field Number</th>
                                        <th style="width:10%" v-if="!formDisabled">Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="isolate in isolateList" :key="isolate.isolateId">
                                        <td v-if="!formDisabled">
                                            <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="goIsolate(isolate.isolateId)"></a> -->
                                            <router-link :to="{ path: '/Isolate/' + isolate.isolateId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                                        </td>
                                        <td>{{isolate.isolateNumber}}</td>
                                        <td>{{isolate.isolateCurationId}}</td>
                                        <td>{{isolate.resourceType}}</td>
                                        <td>{{isolate.fieldNumber}}</td>
                                        <td v-if="!formDisabled"><a class="fa fa-ban" style="font-size: 18px;" v-on:click="deleteIsolate(isolate)"></a></td>
                                    </tr>
                                    <tr v-show="isolateList.length === 0">
                                        <td colspan="5" style="text-align:center"><strong> No matching records </strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="form-group">
                            <label class="col-md-2 control-label">&nbsp;</label>
                            <div class="col-md-4">
                                <div v-show="isolateValidationResult && isolateValidationResult.messages && isolateValidationResult.messages.length > 0">
                                    <span class="has-error">Error on delete:</span>
                                    <ul class="has-error">
                                        <li v-for="message in isolateValidationResult.messages" v-bind:key="message">{{ message }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <button  class="btn btn-primary pull-right" v-on:click="goIsolate()" v-if="!formDisabled">Add Isolated Resource</button>
                        </div>
                    </tab>
                    <tab header="In Progress Site Number Requests">
                        <div class="row">
                            <v-client-table :data="snrGridSpec.tableData" :columns="snrGridSpec.columns" :options="snrGridSpec.options">
                                <template slot="view" slot-scope="props">
                                    <div style="text-align: center;">
                                        <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editRow(props.row.siteNumberRequestId)"></a> -->
                                        <router-link :to="{ path: '/SiteNumberRequest/' + props.row.siteNumberRequestId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                                    </div>
                                </template>
                                </v-client-table>
                        </div>
                    </tab>
                </tabs>
            </form>
            <modal  ref="culturalResourceSearchModal">
                <h3 slot="header">Cultural Resource Search</h3>
                <div slot="body">
                    <div class="form form-horizontal">
                        <div class="">
                            <div class="form-group">
                                <label class="col-md-4 control-label">Smithsonian Number</label>
                                <div class="col-md-8">
                                    <input type="text" class="form-control" v-model="crSearchDto.smithsonianNumber" autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <div class="">
                            <div class="form-group">
                                <label class="col-md-4 control-label">Site Name</label>
                                <div class="col-md-8">
                                    <input type="text" class="form-control" v-model="crSearchDto.siteName" autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <div class="" v-if="isAdmin">
                            <div class="form-group">
                                <div class="col-md-1"></div>
                                <div class="col-md-8">
                                    <label class="control-label text-label" for="crShowInactive">Show Inactive</label>
                                    <input type="checkbox" v-model="crSearchDto.showInactive" class="form-check-input" id="crShowInactive" style="width: 15px; height: 15px;"/>
                                </div>
                            </div>
                        </div>
                        <loader v-if="crSearchLoading"></loader>
                        <div v-if="searchGridSpec.tableData.length > 0" class="well">
                            <div v-if="showAddMessage" id="addMessage"><b>{{showAddMessage}}</b></div>
                            <v-client-table :data="searchGridSpec.tableData" :columns="searchGridSpec.columns" :options="searchGridSpec.options">
                                <template slot="add" slot-scope="props">
                                    <div style="text-align: center">
                                        <a class="fa fa-plus" style="font-size: 18px;" v-on:click="addCulturalResourceRecording(props.row.culturalResourceId)" :disabled="showAddMessage"></a>
                                    </div>
                                </template>
                            </v-client-table>
                        </div>
                        <div v-if="noSearchResults">
                            No Cultural Resources found
                        </div>
                    </div>
                </div>
                <div slot="footer">
                    <div class="row">
                        <button name="buttonSearch" class="btn btn-primary col-md-3" v-on:click="searchCulturalResource()"> Search </button>
                        <button name="buttonCancel" class="btn btn-primary col-md-3" v-on:click="$refs['culturalResourceSearchModal'].close()"> Close </button>
                    </div>
                </div>
            </modal>
        </div>
        <div v-if="isDebug">
            <h2>**Debug**</h2>
            {{selectedRecordingList}}
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import lookupService from '../services/lookup/lookupService'
import culturalResourceRecordingService from '../services/culturalResourceRecordingService'
import investigationService from '../services/investigationService'
import culturalResourceService from '../services/culturalResourceService'
import modal from '../components/Modal.vue'
import loader from '../components/Loader.vue'
import isolateService from '@/services/isolateService'
import { tab, tabs } from 'vue-strap'
import {ServerTable, ClientTable, Event} from 'vue-tables-2'
import { mapState } from 'vuex'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import siteNumberRequestService from '@/services/siteNumberRequestService'
import workflowService from '@/services/workflowService'

export default {
    components: {
        modal,
        loader,
        tabs,
        tab,
        serverTable: ServerTable,
        clientTable: ClientTable,
        event: Event
    },
    data: function () {
        return {
            isDebug: false,
            crSelectionLoading: true,
            recordingTypeList: [],
            recordingTypeEnum: culturalResourceRecordingService.RecordingTypeEnum,
            excludedRecordingTypes: culturalResourceRecordingService.ExcludedRecordingTypes,
            CRRecordingList: [],
            selectedRecordingList: [],
            existingSiteChangeset: [],
            crSearchDto: {},
            crSearchLoading: false,
            noSearchResults: true,
            showAddMessage: null,
            existingSiteList: [],
            newSiteList: [],
            isolateList: [],
            selectdRecordingTypeId: '',
            siteListGridSpec: {
                options: {
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        select: '',
                        edit: 'View/Edit',
                        smithsonianNumber: 'Smithsonian Number',
                        siteName: 'Site Name',
                        recordingType: 'Record Type',
                        isApe: 'In APE',
                        delete: 'delete'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'siteName'
                    }
                }
            },
            searchGridSpec: {
                columns: ['smithsonianNumber', 'siteName', 'add'],
                options: {
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        smithsonianNumber: 'Smithsonian Number',
                        siteName: 'Site Name',
                        add: 'Add'
                    }

                },
                tableData: []
            },
            isolateValidationResult: {},
            crrValidationResult: {},
            snrGridSpec: {
                columns: ['view', 'workflowStatusDescription', 'siteName', 'siteTypeDescription', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        workflowStatusDescription: 'Status',
                        siteName: 'Site Name / Identifier',
                        siteTypeDescription: 'Type',
                        createdDate: 'Created Date'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            }
        }
    },
    computed: {
        isNew: function () {
            return (!this.investigation || !this.investigation.investigationId)
        },
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        isAdmin: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.Administrator, roleService.RoleEnum.ShpoAdministrator])
        },
        isConsultant: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ConsultantUser, roleService.RoleEnum.CLGConsultant])
        },
        isShpoCr: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoCrRoleList)
        },
        isRcAdmin: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ShpoRcAdministrator])
        },
        isShpoRc: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRcRoleList)
        },
        siteListGridSpecColumns: function () {
            if (this.formDisabled && !this.isShpoCrNorm && !this.hasShpoRcDeskReview) {
                return ['smithsonianNumber', 'siteName', 'recordingType', 'isApe']
            } else {
                return ['select', 'edit', 'smithsonianNumber', 'siteName', 'recordingType', 'isApe', 'delete']
            }
        },
        isShpoCrNorm: function () {
            return this.formDisabled && this.isShpoCr && this.isQaqc
        },
        hasShpoRcDeskReview: function () {
            return this.formDisabled && this.isShpoRc
        }
    },
    props: {
        investigation: {},
        formDisabled: { default: false },
        loadOnMount: { default: true },
        isQaqc: { default: false }
    },
    mounted () {
        loggingService.log(this.isDebug, 'CRSelection', 'mounted for projectId ' + this.$route.query.projectId)
        if (this.loadOnMount) this.loadData()
    },
    watch: {
        investigation: function (val) {
            loggingService.log(this.isDebug, 'CRSelection', 'Investigation Changed, reloading')
            this.loadSelectionList()
            this.loadIsolates()
            this.loadSiteNumberRequests()
        },
        selectdRecordingTypeId: function (val) {
            loggingService.log(this.isDebug, 'CRSelection', 'selected recording type')
            this.selectedRecordingList.forEach(id => {
                var selectedCR = this.existingSiteList.find(rec => rec.culturalResourceRecordingId === id)
                selectedCR.recordingTypeId = val
                culturalResourceRecordingService.putInvestigationCrr(this.$http, selectedCR)
            })
        }
    },
    methods: {
        loadData () {
            Promise.all([this.loadRecordingType(), this.loadSelectionList(), this.loadIsolates(), this.loadSiteNumberRequests()]).then(response => {
                loggingService.log(this.isDebug, 'CRSelection', 'Done with all loading')
                this.crSelectionLoading = false
            })
        },
        loadRecordingType () {
            loggingService.log(this.isDebug, 'CRSelection', 'Loading recording type')
            return lookupService.listLookup(this.$http, 'RecordingType').then(response => {
                this.recordingTypeList = response.data
                // .filter(x => {
                //     return !(this.isConsultant && x.id === this.recordingTypeEnum.InternalReview)
                // })
                return response
            })
        },
        loadSelectionList () {
            loggingService.log(this.isDebug, 'CRSelection', 'Loading selectionList for investigation ID ' + this.investigation.investigationId)
            if (this.isNew) {
                loggingService.log(this.isDebug, 'CRSelection', 'New investgation, skipping the loading of CR list')
                return
            }
            var searchDto = {investigationId: this.investigation.investigationId}
            return culturalResourceRecordingService.search(this.$http, searchDto).then(response => {
                loggingService.log(this.isDebug, 'CRSelection', 'potential CR List: ' + response.data.length)
                //filter list for normalization recordings
                response.data = response.data.filter(crr => this.canViewCrr(crr))
                this.newSiteList = response.data.filter(x => {
                    return (!x.fileSearchId && x.recordingTypeId !== culturalResourceRecordingService.RecordingTypeEnum.Migrated)
                })
                //set hasWorkflow flag based on recordingTypeId
                this.newSiteList.forEach((site) => {
                    site.hasWorkflow = this.hasRecording(site.recordingTypeId)
                })
                this.existingSiteList = response.data.filter(x => {
                    return (x.fileSearchId > 0 || x.recordingTypeId === culturalResourceRecordingService.RecordingTypeEnum.Migrated)
                })
                this.newSiteList.forEach(site => {
                    site.initialRecordingType = site.recordingTypeId
                })
                this.existingSiteList.forEach(site => {
                    site.initialRecordingType = site.recordingTypeId
                })
                loggingService.log(this.isDebug, 'CRSelection', 'new site list count: ' + this.newSiteList.length)
                return response
            })
        },
        loadIsolates () {
            if (!this.investigation.investigationId || this.investigation.investigationId === 0) {
                loggingService.log(this.isDebug, 'CRSelection', 'Skipping isolate search, no investigationId')
                return Promise.resolve(1)
            }
            var searchDto = {investigationId: this.investigation.investigationId}
            loggingService.log(this.isDebug, 'CRSelection', 'Searching for isolates for investigation: ' + searchDto.investigationId)
            return isolateService.search(this.$http, searchDto).then(response => {
                this.isolateList = response.data
                return response
            })
        },
        loadSiteNumberRequests () {
            if (this.isNew || !this.investigation.investigationId) {
                return Promise.resolve(1)
            }
            var searchDto = {investigationId: this.investigation.investigationId}
            loggingService.log(this.isDebug, 'CRSelection', 'Searching for site number requests for investigationId: ' + searchDto.investigationId)
            return siteNumberRequestService.search(this.$http, searchDto).then(response => {
                loggingService.log(this.isDebug, 'SiteNumberRequests', 'search complete')
                if (response.data) {
                    this.snrGridSpec.tableData = response.data.filter(x => x.workflowStatusId <= workflowService.SnrWfStatusEnum.PendingApproval)
                }
            })
        },
        goRecording (culturalResourceRecordingId) {
            loggingService.log(this.isDebug, 'CRSelection', 'Go to recording:' + culturalResourceRecordingId)
            this.$router.push('/CulturalResourceRecording/' + culturalResourceRecordingId)
        },
        showSearch () {
            this.crSearchDto = {}
            this.searchGridSpec.tableData = []
            this.noSearchResults = false
            this.$refs['culturalResourceSearchModal'].open()
        },
        searchCulturalResource () {
            loggingService.log(this.isDebug, 'CRSelection', `Searching`)
            this.crSearchLoading = true
            culturalResourceService.search(this.$http, this.crSearchDto).then(response => {
                this.searchGridSpec.tableData = response.data
                this.noSearchResults = (response.data.length === 0)
                this.crSearchLoading = false
                loggingService.log(this.isDebug, 'CRSelection', 'Seach complete: ' + response.data.length)
            })
        },
        addCulturalResourceRecording  (culturalResourceId) {
            loggingService.log(this.isDebug, 'CRSelection', `Adding CR to recording list: ${culturalResourceId}`)
            var selectedCR = this.searchGridSpec.tableData.find(x => {
                return x.culturalResourceId === culturalResourceId
            })

            loggingService.log(this.isDebug, 'CRSelection', `Found Name: ${selectedCR.siteName}, SmithNo: ${selectedCR.smithsonianNumber}`)

            //using array index as tempId to identify record when changing recording type
            var newRecording = {
                investigationId: this.investigation.investigationId,
                siteName: selectedCR.siteName,
                smithsonianNumber: selectedCR.smithsonianNumber,
                culturalResourceId: selectedCR.culturalResourceId,
                hasWorkflow: false,
                recordingTypeId: '',
                tempId: this.newSiteList.length
            }
            this.newSiteList.push(newRecording)
            this.showAddMessage = 'Site ' + selectedCR.siteName + ' has been added.'
            var handle = this
            setTimeout(function () { handle.showAddMessage = null }, 3000)
        },
        setChecked (culturalResourceId, IsApeChecked) {
            loggingService.log(this.isDebug, 'CRSelection', 'setChecked for id: ' + culturalResourceId)
            var newSite = this.newSiteList.find(x => {
                return x.culturalResourceId === culturalResourceId
            })
            var existingSite = this.existingSiteList.find(x => {
                return x.culturalResourceId === culturalResourceId
            })
            if (newSite) {
                newSite.isApe = IsApeChecked
                if (newSite.recordingTypeId === '7' && IsApeChecked) {
                    newSite.recordingTypeId = newSite.initialRecordingType
                }
            }
            if (existingSite) {
                existingSite.isApe = IsApeChecked
                if (existingSite.recordingTypeId === '7' && IsApeChecked) {
                    existingSite.recordingTypeId = existingSite.initialRecordingType
                }
                if (!this.existingSiteChangeset.find(x => { x === culturalResourceId })) {
                    this.existingSiteChangeset.push(culturalResourceId)
                }
            }
        },
        markChanged (culturalResourceRecordingId, event) {
            loggingService.log(this.isDebug, 'CRSelection', `recording type was selected  id: ${culturalResourceRecordingId}, newrecordingType: ${event.target.value}`)
            if (!this.existingSiteChangeset.find(x => x === Number(culturalResourceRecordingId))) {
                this.existingSiteChangeset.push(Number(culturalResourceRecordingId))
            }
            var site = this.existingSiteList.find(x => {
                return x.culturalResourceRecordingId === culturalResourceRecordingId
            })
            if (site) {
                site.recordingTypeId = Number(event.target.value)
                if (site.recordingTypeId === 7) {
                    site.isApe = false
                }
            }
        },
        //TODO: figure out why normal binding isn't working and has to be set through event
        markNew (crr, event) {
            loggingService.log(this.isDebug, 'CRSelection', `recording type was selected  id: ${crr.culturalResourceRecordingId}, newRecordingType: ${event.target.value}`)
            var site = this.newSiteList.find(x => {
                return crr.culturalResourceRecordingId ? x.culturalResourceRecordingId === crr.culturalResourceRecordingId
                    : crr.tempId === x.tempId
            })
            if (site) {
                site.recordingTypeId = Number(event.target.value)
                if (site.recordingTypeId === 7) {
                    site.isApe = false
                }
            }
        },
        selectAll () {
            this.selectedRecordingList = []
            this.existingSiteList.forEach(x => {
                this.selectedRecordingList.push(x.culturalResourceRecordingId)
            })
        },
        optionIsDisabled (recordingTypeId) {
            return (!this.isAdmin && recordingTypeId === this.recordingTypeEnum.Migrated) ||
                (!this.isAdmin && !this.isRcAdmin && recordingTypeId === this.recordingTypeEnum.DeskReview) ||
                (this.isConsultant && recordingTypeId === this.recordingTypeEnum.InternalReview) ||
                (this.isShpoCrNorm && recordingTypeId !== this.recordingTypeEnum.Normalization) ||
                (!this.isAdmin && !this.isShpoCrNorm && recordingTypeId === this.recordingTypeEnum.Normalization) ||
                (this.hasShpoRcDeskReview && recordingTypeId !== this.recordingTypeEnum.InternalReview)
        },
        existingSiteOptionIsDisabled (recordingTypeId, existingRecTypeId) {
            if (!this.hasShpoRcDeskReview) return this.optionIsDisabled(recordingTypeId)
            // if (existingRecTypeId === this.recordingTypeEnum.InternalReview) {
            //     return !this.excludedRecordingTypes.includes(Number(recordingTypeId))
            // } else {
            //     return recordingTypeId !== this.recordingTypeEnum.InternalReview
            // }
            return recordingTypeId !== this.recordingTypeEnum.InternalReview
        },
        submit () {
            //do nothing
        },
        hasRecording (recordingTypeId) {
            return (
                Number(recordingTypeId) > 0 &&
                !this.excludedRecordingTypes.includes(Number(recordingTypeId))
                // Number(recordingTypeId) !== culturalResourceRecordingService.RecordingTypeEnum.NotLocated &&
                // Number(recordingTypeId) !== culturalResourceRecordingService.RecordingTypeEnum.OutsideAPE &&
                // Number(recordingTypeId) !== culturalResourceRecordingService.RecordingTypeEnum.DeskReview
            )
        },
        saveExisting () {
            if (window.confirm('You are about to save your selections from all pages. Do you want to continue?')) {
                loggingService.log(this.isDebug, 'CRSelection', 'Saving List')
                this.existingSiteChangeset.forEach(changeSetId => {
                    loggingService.log(this.isDebug, 'CRSelection', 'Looking for ' + changeSetId)
                    var selectedCR = this.existingSiteList.find(x => {
                        return x.culturalResourceRecordingId === changeSetId
                    })
                    if (selectedCR && selectedCR.recordingTypeId) {
                        // //shpo rc desk review: only save desk reviews
                        // if (!this.isAdmin && this.hasShpoRcDeskReview && selectedCR.recordingTypeId !== this.recordingTypeEnum.InternalReview) {
                        //     console.log('skipping this CR', selectedCR)
                        //     return
                        // }
                        loggingService.log(this.isDebug, 'CRSelection', 'saving ' + changeSetId)
                        culturalResourceRecordingService.putInvestigationCrr(this.$http, selectedCR).then(result => {
                            if (result.data.isValid) {
                                loggingService.log(this.isDebug, 'CRSelection', `resetting value: ${selectedCR.recordingTypeId}`)
                                //HACK: because result from server doesnt have hasWorkflow property
                                selectedCR.hasWorkflow = this.hasRecording(selectedCR.recordingTypeId)
                                selectedCR.initialRecordingType = selectedCR.recordingTypeId
                                //this.$refs.existingSiteGrid.refresh()
                            }
                        })
                    }
                })
                this.existingSiteChangeset = []
            }
        },
        saveNew () {
            if (window.confirm('You are about to save your selections from all pages. Do you want to continue?')) {
                loggingService.log(this.isDebug, 'CRSelection', 'Saving List')
                var tempNewSiteList = []
                this.newSiteList.forEach((x, index) => {
                    loggingService.log(this.isDebug, 'CRSelection', `Looking at ${x.smithsonianNumber} with recording type ${x.recordingTypeId}`)
                    //shpo CR: only save normalization CRRs
                    if (!this.isAdmin && this.isShpoCrNorm && x.recordingTypeId !== this.recordingTypeEnum.Normalization) {
                        tempNewSiteList.push(x)
                    //shpo rc desk review: only save desk reviews/new crr's
                    } else if (!this.isAdmin && this.hasShpoRcDeskReview && !!x.culturalResourceRecordingId) {
                        tempNewSiteList.push(x)
                    } else if (x.recordingTypeId !== '') {
                        loggingService.log(this.isDebug, 'CRSelection', 'saving new ' + x.smithsonianNumber)
                        culturalResourceRecordingService.putInvestigationCrr(this.$http, x).then(result => {
                            if (result.data.isValid) {
                                var data = result.data.objectList[0]
                                //HACK: because result from server doesnt have hasWorkflow property
                                data.hasWorkflow = this.hasRecording(data.recordingTypeId)
                                data.smithsonianNumber = x.smithsonianNumber
                                data.initialRecordingType = data.recordingTypeId
                                tempNewSiteList.push(data)
                            }
                        })
                    } else {
                        tempNewSiteList.push(x)
                    }
                })
                this.newSiteList = tempNewSiteList
            }
        },
        goIsolate (isolateId) {
            if (isolateId) {
                this.$router.push('/Isolate/' + isolateId)
            } else {
                this.$router.push('/Isolate?investigationId=' + this.investigation.investigationId)
            }
        },
        deleteIsolate (isolate) {
            if (confirm(`Are you sure you wish to delete isolate ${isolate.isolateNumber}?`)) {
                loggingService.log(this.isDebug, 'CRSelection', 'Deleting isolate id: ' + isolate.isolateNumber)
                isolateService.remove(this.$http, isolate.isolateId).then(response => {
                    this.isolateValidationResult = response.data
                    this.loadIsolates()
                })
            }
        },
        deleteRecording (crr) {
            this.crrValidationResult = []
            if (confirm(`Are you sure you wish to delete site ${crr.smithsonianNumber}?`)) {
                if (crr.culturalResourceRecordingId > 0) {
                    culturalResourceRecordingService.remove(this.$http, crr.culturalResourceRecordingId).then(response => {
                        this.crrValidationResult = response.data
                        this.loadSelectionList()
                    })
                } else {
                    this.loadSelectionList()
                }
            }
        },
        canViewCrr (crr) {
            return this.isShpoCr || crr.recordingTypeId !== culturalResourceRecordingService.RecordingTypeEnum.Normalization
        },
        addFileSearchSnrSites () {
            this.crSelectionLoading = true
            investigationService.addFileSearchSnrSites(this.$http, this.investigation).then(result => {
                var addedSites = result.data.objectList || []
                addedSites.forEach((site) => {
                    site.hasWorkflow = this.hasRecording(site.recordingTypeId)
                    site.initialRecordingType = site.recordingTypeId
                    //SNR Site
                    if (site.siteNumberRequestId && !site.fileSearchId) this.newSiteList.push(site)
                    //file search site
                    if (site.fileSearchId) this.existingSiteList.push(site)
                })
                this.crSelectionLoading = false
                return result
            }).catch(e => {
                this.crSelectionLoading = false
            })
        }
    }
}
</script>

<style>
#addMessage {
    text-align: center;
    font-size: 1.5em;
    padding-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// CulturalResourceSelection.vue?7715555c